import { render } from "./AllxAdditionalAdhesives.vue?vue&type=template&id=2f3cddb9"
import script from "./AllxAdditionalAdhesives.vue?vue&type=script&lang=js"
export * from "./AllxAdditionalAdhesives.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__